import { colors } from '&assets/constants/colors';
import { device } from '&assets/constants/responsiveness';
import styled from 'styled-components';

const randomColors = ['#011EF6', '#B4E4DC', '#E1F5F1'];

interface Props {
	index?: number;
}

export const BoxWrapper = styled.div<Props>`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	z-index: 2;
	.title {
		font-family: 'Segnifier-Regular';
		height: 100px;
	}
	.description {
		height: 100px;
		display: flex;
		align-items: flex-end;
		width: 125px;
		font-size: 15px;
		text-align: center;
	}

	.box {
		width: 24px;
		height: 24px;
		flex-shrink: 0;
		background: ${(props) => randomColors[props.index ? props.index % 3 : 0]};
		&::before {
			content: '';
			display: flex;
			width: 1px;
			height: 26px;
			margin: auto;
			margin-top: -26px;
			opacity: 0.5;
			background: rgba(55, 73, 75, 0.8);
		}
		&::after {
			content: '';
			display: flex;
			width: 1px;
			height: 26px;
			margin: auto;
			margin-top: 24px;
			opacity: 0.5;
			background: rgba(55, 73, 75, 0.8);
		}
	}

	@media ${device.tablet} {
		.content {
			padding: 20px;
			width: 100%;
			box-sizing: border-box;
		}
	}

	@media ${device.mobile} {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		z-index: 2;
		width: 100%;
		margin-bottom: 100px;
		.title {
			margin: 0;
			width: 33.33%;
			height: auto;
		}
		.description {
			margin: 0;
			width: 33.33%;
			text-align: end;
			height: auto;
		}

		.box {
			width: 24px;
			height: 24px;
			flex-shrink: 0;
			background: ${(props) => randomColors[props.index ? props.index % 3 : 0]};
			&::before {
				display: none;
			}
			&::after {
				display: none;
			}
		}
	}
`;

export const ChallengeTimelineWrapper = styled.div`
	min-height: 300px;
	max-height: fit-content;
	box-sizing: border-box;
	width: 100%;
	.header {
		display: flex;
		justify-content: center;
		align-items: center;
		color: ${colors.textDark};
		height: 170px;
		font-family: 'Segnifier-Regular';
		text-align: center;
		font-size: 50.07px;
		font-style: normal;
		font-weight: 400;
		line-height: 58px; /* 115.837% */
		letter-spacing: -1.56px;
		background: #e1f5f1;
	}
	.content {
		height: 100%;
		padding: 50px 0px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		.boxes {
			display: flex;
			justify-content: space-around;
			flex-direction: row;
			align-items: center;
			position: relative;
			.middle-line {
				position: absolute;
				width: 100%;
				height: 1px;
				opacity: 0.5;
				background: rgba(55, 73, 75, 0.8);
			}
		}
	}

	@media ${device.tablet} {
		.content {
			padding: 20px;
			width: 100%;
			box-sizing: border-box;
		}
	}

	@media ${device.mobile} {
		.content {
			padding: 20px;
			width: 100%;
			box-sizing: border-box;
			.boxes {
				justify-content: space-around;
				flex-direction: column;
				align-items: center;
				.middle-line {
					position: absolute;
					height: 100%;
					width: 1px;
					opacity: 0.5;
					background: rgba(55, 73, 75, 0.8);
				}
			}
			.time-box {
				display: flex;
				flex-direction: row;
				justify-content: center;
				align-items: center;
				z-index: 2;
				width: 100%;
				margin: 50px 0;
				.title {
					margin-bottom: 0;
					margin: 0;
				}
				.description {
					margin-top: 0;
					margin: 0;
				}
				.box {
					margin: 0 50px;
					transform: rotate(90deg);
				}
			}
		}
	}
`;
